module.exports = new __parcel__URL__("ticket.4a9c65da.svg").toString();